import axios from 'axios';

import labelEN from '@data/translation/labelEN';
import labelFR from '@data/translation/labelFR';
import labelES from '@data/translation/labelES';

let lang = {};
/* LABELS */

const getLangFromUrl = () => {
    const langId = (window as any).langId as string | undefined; // Forza TypeScript a riconoscere langId
    console.log('vincenzo', langId);
    if (!langId) return labelEN;

    switch (langId) {
        case '-25':
            return labelFR;
        case '-50':
            return labelES;
        default:
            return labelEN;
    }
};

const langLabels = getLangFromUrl();

export const getLabels = async langUrl => {
    if (langUrl) {
        await axios
            .get(langUrl)
            .then(function (response) {
                lang = response.data;
            })
            .catch(function (error) {
                console.error('>>> Get labels => error status:', error.status, ', error: ', error);
            });
    }
};

export const getLabelFallback = (label: keyof typeof labelEN) => {
    return langLabels[label] || labelEN[label] || label;
};

/* DEFINE DEVICE */
export const isMobile = {
    Android: () => {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: () => {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: () => {
        return (
            /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1)
        );
    },
    Opera: () => {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: () => {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: () => {
        return isMobile.Android() ||
            isMobile.BlackBerry() ||
            isMobile.iOS() ||
            isMobile.Opera() ||
            isMobile.Windows()
            ? true
            : false;
    },
};

/* STORE UTILS */
export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties,
    };
};

/*SERVICE UTILS*/
/**
 * Read the content of the file given in input and return a Promise object of its content
 * @param string file
 * @returns {Promise<any>} Promise
 */
export const readFile = async (file: string): Promise<any> => {
    const data = await fetch(file);
    const dataJson = await data.json();
    return new Promise((resolve, reject) => {
        if (dataJson) resolve({ data: dataJson });
        reject();
    });
};

export function sleep(ms: number): (p: Promise<any>) => any {
    return function (x: any) {
        return new Promise(resolve => setTimeout(() => resolve(x), ms));
    };
}

export async function getMockedFile(file: string) {
    return await readFile(file).then(sleep(500)); // add a delay to simulate fetching
}

/*COMMON UTILS*/
/*repace {str} in a string with JSX element*/
export const replaceStringWithElement = (
    text: string,
    str: string,
    element: JSX.Element
): (JSX.Element | string)[] => {
    const index = 1;
    const textArray: (JSX.Element | string)[] = text.split(`{${str}}`);
    return [...textArray.slice(0, index), element, ...textArray.slice(index)];
};

/**
 * Capitalize the first letter of a string
 *
 * @param {(string)} str
 * @return {*}  {string}
 */

export const capitalizeFirstLetter = (str: string): string =>
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

/**
 * The function below returns the a substring of the entire phone number
 *
 * @param {(string)} phoneNumber
 * @param {(number)} startIndex
 * @param {(number)} endIndex
 * @return {*}  {string}
 */

export const getPartialPhoneNumber = (
    phoneNumber: string,
    startIndex: number,
    endIndex: number
): string => {
    const onlyNumbers = phoneNumber.replace(/\D/g, '');
    return onlyNumbers.substring(startIndex, endIndex);
};

/**
 * The function below returns the a substring of the entire phone number
 *
 * @param {(T)} formData the form data including form status

 * @return {boolean}  true if all form fields have values and not errors otherwise false
 */

export function isValidForm<T>(formData: T): boolean {
    return Object.keys(formData).some(function (key) {
        return formData[key].error || !formData[key].value;
    });
}

export const returnValueIf = (value: any, condition: boolean) => (condition ? value : undefined);

export const range = (start: number, stop: number, inclusive = false) => {
    const max = Math.max(stop, start);
    const min = Math.min(stop, start);
    const elements = max - min + (inclusive ? 1 : 0);

    const range = new Array(elements).fill(min).map((n, i) => n + i);

    return start > stop ? range.reverse() : range;
};

export const formatPhone = (phone: string) => {
    const numbers = phone.replace(/\D/g, '');
    return `(${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6)}`;
};

export const base64IsImage = (base64: string) => base64.match(/\/(png|jpg|jpeg|gif|bmp|tiff);/);

export const base64FileToImage = (base64: string) => base64.replace('data:@file', 'data:image');

/*PRESCRIPTION UTILS*/
/**
 * @param values array of values
 * @param toFixed fixed decimal string of the string returned in the name field. Can be undefined
 * @param defaultVal default will be true only for the value equal to this. Can be undefined
 * @returns an array of object in form {name: string, value: number, default: bool} name is the value shown, value the actual number,
 * default represents if is the default value
 */
export const getSimplePrescriptionValuesArray = (
    values?: string[] | number[],
    toFixed?: number,
    defaultVal?: number
) => {
    let valuesArray = [];

    values?.map(val => {
        valuesArray.push({
            name: toFixed != undefined ? Number(val).toFixed(toFixed) : '' + Number(val),
            value: Number(val),
            default: defaultVal && defaultVal === Number(val),
        });
    });

    return valuesArray;
};
